module.exports = "<dk-main-bar></dk-main-bar>\r\n<div class=\"container\">\r\n<dk-tiles></dk-tiles>\r\n</div>"